/* ============================================================================
 * WTS · Selector de medidas con precio — PRODUCCIÓN (sustituye a Intelligems)
 * Archivo: assets/wts-size-selector.js
 *
 * Unifica las 4 personalizaciones activas que hacían lo mismo:
 *   - Price selector ALL                         (base de este archivo)
 *   - Rollout of Ficha packs medidas - Price selector
 *   - Rollout of Ficha colchón medidas - Compare at
 *   - Rollout of Ficha canapé medidas - Compare at
 *
 * Qué hace (condiciones actuales):
 *   - Corre en cualquier ficha cuyo producto tenga una opción "Medidas"/"Medida"
 *     con 2 o más valores. Si no → fail-open (ficha original).
 *   - Soporta los dos selectores del tema: <select name="options[Medidas]">
 *     y radios <fieldset> (almohadas, canapé apertura lateral).
 *   - Rejilla de botones medida + precio. ≤ 6 medidas → todas visibles.
 *     Más → destacadas (90x190, 105x190, 135x190, 150x190, 180x200); si casan
 *     menos de 3, las del metafield custom.featured-size; si tampoco, las
 *     primeras del desplegable. El resto en "Ver el resto".
 *   - Badge "La más vendida" en 135x190 (si existe).
 *   - Preselección de la medida más barata con stock, salvo URL con ?variant=.
 *   - Nota "Precio en {medida}" bajo el precio tras la preselección.
 *   - Si el producto tiene otras opciones (color, firmeza…), la rejilla
 *     enseña solo la combinación activa y se repinta al cambiarlas.
 *   - Verificación: si la variante del carrito no coincide → fail-open.
 *
 * Qué se ha QUITADO frente a Intelligems:
 *   - Banner de packs ("-10% EXTRA APLICADO EN EL CARRITO" / "10% ya aplicado").
 *   - Hoja con marcador --ig-hide-*, inyección de CSS y convivencia ig-/igm-
 *     (el CSS va ahora en base.css).
 *
 * Fail-open: añade la clase .wts-sz-off a <html>; base.css deja de ocultar
 * el selector del tema y se ve la ficha original.
 *
 * Debug: window.__wtsSizes
 * ============================================================================ */

(function () {
  'use strict';

  var CFG = {
    optionNames: ['Medidas', 'Medida'],
    productPath: /\/products\/([^/?#]+)/,

    /* Solo la sección principal (clave "main" en todas las plantillas). Así no
       se toca el featured-product que algunas plantillas (tango, salsa,
       colchones-v2-2025, funk_pack_colchon…) pintan más abajo con el mismo id. */
    scopeSelector: '[id^="ProductInfo-"][id$="__main"], [id^="ProductInfo-"]',
    excludeSelector: '.product-form--sticky, .sticky-cart-top, #sticky-cart, num-sticky-addcart, [data-product-sticky-bar], .stickyCart',
    variantIdSelector: 'form[id^="product-form-"][id$="__main"] input[name="id"], form[action*="/cart/add"] input[name="id"]',

    featured: ['90x190', '105x190', '135x190', '150x190', '180x200'],
    /* Medidas destacadas del metafield custom.featured-size (lo imprime
       main-product.liquid en <script id="wts-featured-sizes">). Sustituye a
       las pastillas de num-block-size, que se eliminan. */
    featuredJsonSelector: '#wts-featured-sizes',
    pillsSelector: '.block-size__btn',   /* compatibilidad si sigue el snippet antiguo */
    minFeatured: 3,
    showAllIfUpTo: 6,

    sufijoNumerico: ' cm',      /* "70" → "70 cm" */
    etiquetas: {},              /* forzar etiqueta: { '70': '70 cm (cama de 80-90)' } */

    preseleccion: 'mas-barata', /* 'mas-barata' | '135x190' | null */
    soloDisponibles: true,
    destacarPreseleccion: true,
    autoOpenRest: false,

    bestBadge: 'La más vendida',
    bestSize: '135x190',

    priceSelector: '[id^="price-"][id$="__main"], [id^="ProductInfo-"][id$="__main"] .price, [id^="price-"]',
    priceNoteText: 'Precio en {medida}',

    labelRest: 'Ver el resto de medidas',
    labelRestClose: 'Ocultar el resto de medidas',
    soldOut: 'Sin stock',

    esperaSelector: 50,         /* intentos × 200 ms */
    debug: false
  };

  var D = { pasos: [] };
  function log(m, x) { D.pasos.push(x === undefined ? m : m + ': ' + JSON.stringify(x)); if (CFG.debug) console.log('[wts-sz]', m, x || ''); }

  var SIZE_RE = /(\d{2,3})\s*[x×X]\s*(\d{2,3})/;
  function sizeOf(s) { var m = String(s || '').match(SIZE_RE); return m ? m[1] + 'x' + m[2] : null; }
  function norm(s) { s = String(s == null ? '' : s).trim(); return sizeOf(s) && /^\s*\d{2,3}\s*[x×X]\s*\d{2,3}\s*$/.test(s) ? sizeOf(s) : s.toLowerCase(); }
  function money(c) { return (c / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function etiqueta(v) {
    var s = String(v).trim();
    if (CFG.etiquetas && CFG.etiquetas[s]) return CFG.etiquetas[s];
    if (/^\d{2,3}\s*[x×X]\s*\d{2,3}$/.test(s)) return sizeOf(s).replace('x', ' × ');
    if (/^\d{2,3}$/.test(s)) return s + (CFG.sufijoNumerico || '');
    return s;
  }

  /* ----------------------------------------------------------- fail-open */
  function failOpen(motivo) {
    D.ok = false; D.motivo = motivo;
    document.documentElement.classList.add('wts-sz-off');
    [].forEach.call(document.querySelectorAll('.wts-sz,.wts-pricenote'), function (n) { n.remove(); });
    [].forEach.call(document.querySelectorAll('[data-wts-hidden]'), function (n) {
      n.style.removeProperty('display'); n.removeAttribute('data-wts-hidden');
    });
    log('fail-open', motivo);
  }

  /* ------------------------------------------------------------- datos */
  function getProduct() {
    return fetch(location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  function analizar(product) {
    var names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o && o.name; });
    var wanted = CFG.optionNames.map(function (n) { return n.toLowerCase(); });
    var idx = -1;
    names.forEach(function (n, i) { if (idx === -1 && wanted.indexOf(String(n || '').trim().toLowerCase()) !== -1) idx = i; });
    if (idx === -1) return { motivo: 'sin opción ' + CFG.optionNames.join('/') + ' (opciones: ' + names.join(', ') + ')' };
    var keys = ['option1', 'option2', 'option3'];
    var key = keys[idx];
    var list = (product.variants || []).map(function (v) {
      return {
        id: v.id, val: String(v[key]).trim(), price: v.price, available: v.available,
        otros: keys.filter(function (_, i) { return i !== idx; }).map(function (k) { return v[k] || ''; }).join('|')
      };
    });
    var distintas = {};
    list.forEach(function (v) { distintas[v.val] = 1; });
    if (Object.keys(distintas).length < 2) return { motivo: 'menos de 2 medidas' };
    D.opcion = names[idx]; D.numOpciones = names.length;
    return { nombre: names[idx], list: list };
  }

  function grupoDe(list, otros) {
    var g = {}, dup = null;
    list.forEach(function (v) {
      if (v.otros !== otros) return;
      if (g[v.val]) dup = v.val;
      g[v.val] = v;
    });
    if (dup) throw new Error('medida ' + dup + ' repetida en la misma combinación');
    return g;
  }

  function excluido(n) { return CFG.excludeSelector && n.closest(CFG.excludeSelector); }

  /* ------------------------------------------ selector del tema (2 tipos) */
  function findPicker(nombre) {
    var root = document.querySelector(CFG.scopeSelector) || document;
    var i;

    /* a) desplegable */
    var sels = root.querySelectorAll('select');
    for (i = 0; i < sels.length; i++) {
      var s = sels[i];
      if (excluido(s) || s.name !== 'options[' + nombre + ']') continue;
      return {
        tipo: 'select',
        el: s,
        host: s.closest('.product-form__input--dropdown') || s.parentNode,
        values: function () { return [].map.call(this.el.options, function (o) { return String(o.value).trim(); }); },
        current: function () { return String(this.el.value).trim(); },
        set: function (val) {
          for (var k = 0; k < this.el.options.length; k++) {
            if (String(this.el.options[k].value).trim() === val) {
              this.el.value = this.el.options[k].value;
              this.el.dispatchEvent(new Event('input', { bubbles: true }));
              this.el.dispatchEvent(new Event('change', { bubbles: true }));
              return true;
            }
          }
          return false;
        }
      };
    }

    /* b) radios (almohadas, canapé lateral) */
    var radios = [].filter.call(root.querySelectorAll('input[type="radio"]'), function (r) {
      return !excluido(r) && (r.name === nombre || r.name === 'options[' + nombre + ']');
    });
    if (radios.length) {
      var fs = radios[0].closest('fieldset') || radios[0].parentNode;
      return {
        tipo: 'radios',
        el: fs,
        host: fs,
        inputs: function () {
          return [].filter.call(this.el.querySelectorAll('input[type="radio"]'), function (r) {
            return r.name === nombre || r.name === 'options[' + nombre + ']';
          });
        },
        values: function () { return this.inputs().map(function (r) { return String(r.value).trim(); }); },
        current: function () {
          var c = this.inputs().filter(function (r) { return r.checked; })[0];
          return c ? String(c.value).trim() : null;
        },
        set: function (val) {
          var r = this.inputs().filter(function (x) { return String(x.value).trim() === val; })[0];
          if (!r) return false;
          r.checked = true;
          r.dispatchEvent(new Event('input', { bubbles: true }));
          r.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      };
    }
    return null;
  }

  function variantIdInput() {
    var ins = document.querySelectorAll(CFG.variantIdSelector);
    for (var i = 0; i < ins.length; i++) if (!excluido(ins[i])) return ins[i];
    return null;
  }

  function medidaMasBarata(g) {
    var mejor = null, todas = null;
    Object.keys(g).forEach(function (s) {
      if (!todas || g[s].price < g[todas].price) todas = s;
      if (g[s].available && (!mejor || g[s].price < g[mejor].price)) mejor = s;
    });
    if (!CFG.soloDisponibles) return todas;
    if (mejor) return mejor;
    D.masBarataAgotada = true;
    return todas;
  }

  function makeOption(v, isBest) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wts-sz__opt';
    b.dataset.val = v.val;
    b.setAttribute('aria-pressed', 'false');
    if (!v.available) b.disabled = true;
    b.innerHTML = (isBest && CFG.bestBadge ? '<em>' + esc(CFG.bestBadge) + '</em>' : '') +
      '<b>' + esc(etiqueta(v.val)) + '</b><i>' + (v.available ? money(v.price) : esc(CFG.soldOut)) + '</i>';
    return b;
  }

  function metafieldDestacadas() {
    var el = document.querySelector(CFG.featuredJsonSelector);
    if (!el) return [];
    try { var a = JSON.parse(el.textContent); return Array.isArray(a) ? a.map(function (x) { return String(x).trim(); }) : []; }
    catch (e) { return []; }
  }

  function claveDe(grupo, texto) {
    var n = norm(texto), ks = Object.keys(grupo);
    for (var i = 0; i < ks.length; i++) if (norm(ks[i]) === n) return ks[i];
    return null;
  }

  /* ------------------------------------------------- selector de medidas */
  function buildSizes(pk, info) {
    var list = info.list;
    var byId = {};
    list.forEach(function (v) { byId[v.id] = v; });

    var wrap = document.createElement('div');
    wrap.className = 'wts-sz';

    function montar() {
      pk.host.appendChild(wrap);
      /* Cinturón: si base.css no casó con este bloque, lo oculta el JS */
      [].forEach.call(pk.host.children, function (n) {
        if (n === wrap) return;
        n.style.setProperty('display', 'none', 'important');
        n.setAttribute('data-wts-hidden', '1');
      });
    }
    montar();

    var grupo = {}, otrosActual = null, restOpen = false;

    function varianteActiva() {
      var inp = variantIdInput();
      return inp ? byId[Number(inp.value)] || null : null;
    }
    function orden() { return pk.values().filter(function (v) { return grupo[v]; }); }

    function render(objetivo) {
      var vals = orden();
      Object.keys(grupo).forEach(function (k) { if (vals.indexOf(k) === -1) vals.push(k); });
      var featured, rest;
      if (vals.length <= CFG.showAllIfUpTo) {
        featured = vals; rest = []; D.destacadasOrigen = 'todas';
      } else {
        var base = (CFG.featured || []).map(function (f) { return claveDe(grupo, f); }).filter(Boolean);
        D.destacadasOrigen = 'CFG.featured';
        if (base.length < CFG.minFeatured) {
          var pills = [];
          metafieldDestacadas().concat([].map.call(document.querySelectorAll(CFG.pillsSelector), function (p) { return p.textContent; }))
            .forEach(function (t) {
              var k = claveDe(grupo, t);
              if (k && pills.indexOf(k) === -1) pills.push(k);
            });
          if (pills.length >= CFG.minFeatured) { base = pills; D.destacadasOrigen = 'metafield featured-size'; }
          else { base = vals.slice(0, CFG.showAllIfUpTo); D.destacadasOrigen = 'primeras del desplegable'; }
        }
        featured = base.filter(function (k, i) { return base.indexOf(k) === i; });
        if (CFG.destacarPreseleccion && objetivo && featured.indexOf(objetivo) === -1) {
          featured.push(objetivo);
          D.preselecDestacadaForzada = objetivo;
        }
        rest = vals.filter(function (s) { return featured.indexOf(s) === -1; });
      }

      var best = CFG.bestSize ? claveDe(grupo, CFG.bestSize) : null;
      wrap.innerHTML = '';
      var grid = document.createElement('div');
      grid.className = 'wts-sz__grid' + (featured.length <= 2 ? ' wts-sz__grid--n' + featured.length : '');
      featured.forEach(function (s) { grid.appendChild(makeOption(grupo[s], s === best)); });
      wrap.appendChild(grid);

      if (rest.length) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'wts-sz__more';
        more.innerHTML = '<span class="wts-sz__moretxt"></span>' +
          '<svg class="wts-sz__caret" width="11" height="7" viewBox="0 0 12 8" aria-hidden="true">' +
          '<path d="M1 1.5 6 6.5 11 1.5" fill="none" stroke="currentColor" stroke-width="1.8" ' +
          'stroke-linecap="round" stroke-linejoin="round"/></svg>';
        var restBox = document.createElement('div');
        restBox.className = 'wts-sz__rest';
        var rg = document.createElement('div');
        rg.className = 'wts-sz__grid' + (rest.length <= 2 ? ' wts-sz__grid--n' + rest.length : '');
        rest.forEach(function (s) { rg.appendChild(makeOption(grupo[s], s === best)); });
        restBox.appendChild(rg);

        var cur = pk.current();
        if (CFG.autoOpenRest && cur && rest.indexOf(cur) !== -1) restOpen = true;
        var setOpen = function (open) {
          restOpen = open;
          restBox.classList.toggle('is-open', open);
          more.setAttribute('aria-expanded', String(open));
          more.querySelector('.wts-sz__moretxt').textContent =
            open ? CFG.labelRestClose : CFG.labelRest + ' (' + rest.length + ')';
        };
        setOpen(restOpen);
        more.addEventListener('click', function () { setOpen(!restOpen); });
        wrap.appendChild(more);
        wrap.appendChild(restBox);
      }
      D.featured = featured.length; D.resto = rest.length;
      paint();
    }

    function paint() {
      var cur = pk.current();
      [].forEach.call(wrap.querySelectorAll('.wts-sz__opt'), function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.val === cur));
      });
    }

    function apply(val) {
      if (!pk.set(val)) return false;
      verificar(grupo[val]);
      return true;
    }

    function verificar(esperada) {
      if (!esperada) return;
      var t0 = Date.now();
      var t = setInterval(function () {
        var inp = variantIdInput();
        var id = inp ? Number(inp.value) : null;
        if (id === esperada.id) { clearInterval(t); D.verificacion = 'ok'; return; }
        if (Date.now() - t0 > 2500) {
          clearInterval(t);
          D.verificacion = { esperada: esperada.id, carrito: id };
          failOpen('la variante del carrito no coincide con la medida marcada');
        }
      }, 150);
    }

    function sync() {
      var v = varianteActiva();
      if (!v) { paint(); return; }
      if (v.otros !== otrosActual) {
        otrosActual = v.otros;
        grupo = grupoDe(list, otrosActual);
        render(null);
        log('grupo cambiado', { otros: otrosActual, medidas: Object.keys(grupo).length });
      } else {
        paint();
      }
    }

    /* --- nota de precio --- */
    var nota = null, notaTimer = null;
    function anclaPrecio() {
      var partes = String(CFG.priceSelector || '').split(',');
      for (var i = 0; i < partes.length; i++) {
        var sel = partes[i].trim();
        if (!sel) continue;
        var nodos = document.querySelectorAll(sel);
        for (var j = 0; j < nodos.length; j++) {
          var n = nodos[j];
          if (excluido(n) || n.closest('.wts-sz')) continue;
          return n;
        }
      }
      return null;
    }
    function pintarNota(val) {
      if (nota && document.body.contains(nota)) return;
      var ancla = anclaPrecio();
      if (!ancla) { D.nota = 'no encontré el bloque de precio'; return; }
      nota = document.createElement('p');
      nota.className = 'wts-pricenote';
      nota.textContent = String(CFG.priceNoteText).replace('{medida}', etiqueta(val));
      ancla.parentNode.insertBefore(nota, ancla.nextSibling);
      D.nota = nota.textContent;
    }
    function quitarNota() {
      D.notaActiva = false;
      if (notaTimer) { clearInterval(notaTimer); notaTimer = null; }
      if (nota && nota.parentNode) nota.parentNode.removeChild(nota);
      nota = null;
    }

    /* --- arranque --- */
    var activa = varianteActiva() || list[0];
    otrosActual = activa.otros;
    grupo = grupoDe(list, otrosActual);

    var enTema = pk.values();
    D.sinCasarEnTema = Object.keys(grupo).filter(function (k) { return enTema.indexOf(k) === -1; });
    if (D.sinCasarEnTema.length === Object.keys(grupo).length) throw new Error('las medidas del producto no casan con el selector del tema');

    var objetivo = null;
    D.respetaURL = /[?&]variant=/.test(location.search);
    if (!D.respetaURL && CFG.preseleccion) {
      if (CFG.preseleccion === 'mas-barata') objetivo = medidaMasBarata(grupo);
      else objetivo = claveDe(grupo, CFG.preseleccion);
    }
    D.preselecObjetivo = objetivo;
    D.preselecPrecio = objetivo ? money(grupo[objetivo].price) : null;

    render(objetivo);

    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('.wts-sz__opt');
      if (!b || b.disabled) return;
      e.preventDefault();
      quitarNota();
      apply(b.dataset.val);
    });

    D.preseleccion = objetivo && objetivo !== pk.current() ? apply(objetivo) : (objetivo ? 'ya estaba' : false);
    paint();

    if (objetivo && D.preseleccion && CFG.priceNoteText) {
      D.notaActiva = true;
      setTimeout(function () {
        if (!D.notaActiva) return;
        pintarNota(objetivo);
        notaTimer = setInterval(function () {
          if (!D.notaActiva) { clearInterval(notaTimer); notaTimer = null; return; }
          if (!nota || !document.body.contains(nota)) pintarNota(objetivo);
        }, 250);
        setTimeout(function () { if (notaTimer) { clearInterval(notaTimer); notaTimer = null; } }, 4000);
      }, 350);
    }

    /* Cambios posteriores (medida, otra opción, barra fija) y re-pintado del tema */
    var ultimoId = null;
    setTimeout(function () {
      var inp = variantIdInput();
      ultimoId = inp ? inp.value : null;
      var loop = setInterval(function () {
        if (D.ok === false) { clearInterval(loop); return; }
        try {
          if (!wrap.isConnected || !pk.host.isConnected) {
            var nuevo = findPicker(info.nombre);
            if (!nuevo) return;
            pk = nuevo; montar(); render(null);
            log('selector re-montado');
          }
          var i2 = variantIdInput();
          var id = i2 ? i2.value : null;
          if (id === ultimoId) return;
          ultimoId = id;
          if (D.notaActiva) quitarNota();
          sync();
        } catch (err) { clearInterval(loop); failOpen(err.message); }
      }, 300);
    }, 1200);

    D.tipo = pk.tipo;
    D.medidas = Object.keys(grupo).length;
    log('selector construido', { tipo: pk.tipo, medidas: D.medidas, preseleccion: objetivo, precio: D.preselecPrecio });
  }

  /* ----------------------------------------------------------- arranque */
  function start() {
    window.__wtsSizes = D;
    D.url = location.pathname;
    if (!CFG.productPath.test(location.pathname)) { failOpen('no es ficha de producto'); return; }

    getProduct()
      .then(function (p) {
        D.titulo = p.title;
        var info = analizar(p);
        if (!info.list) { failOpen(info.motivo); return; }
        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          var pk = findPicker(info.nombre);
          if (pk) {
            clearInterval(timer);
            if (pk.el.dataset.wtsDone) return;
            pk.el.dataset.wtsDone = '1';
            /* Transición: bloquea los JS de Intelligems (ig-/igm-) si siguen activos */
            pk.el.dataset.igDone = '1';
            pk.el.dataset.igmDone = '1';
            D.intentos = tries;
            try { buildSizes(pk, info); D.ok = true; }
            catch (err) { failOpen(err.message); }
          } else if (tries > CFG.esperaSelector) {
            clearInterval(timer);
            D.diagnostico = {
              scope: !!document.querySelector(CFG.scopeSelector),
              selects: [].map.call(document.querySelectorAll('select'), function (s) { return s.name; }),
              radios: document.querySelectorAll('input[type="radio"]').length,
              inputId: !!variantIdInput()
            };
            failOpen('no se encontró el selector de ' + info.nombre);
          }
        }, 200);
      })
      .catch(function (err) { failOpen(err.message); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();